import React from 'react';
import $ from "jquery";
import Trumbowyg from 'react-trumbowyg';

const TextEditor = ({data, handleOnChange}) => {
    return (
        <div style={{background: "#fff"}}>
            <Trumbowyg
                id="trumbowyg"
                data={data}
                onChange={handleOnChange}
            />
        </div>
    )
}

export default TextEditor;